module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-29e9f4cf5b22f482070cff1d8381088d.jpg";